<template>
  


  <div class="" style="width:1000px;position:relative">
 
    <!-- 封装弹框 -->
      
              <el-tabs v-model="activeIndex" @tab-click="handleTabClick" type="border-card">
            
                 <div  class="" style="margin-bottom: 0px;" v-if="this.tabname =='tab1' || this.tabname =='tab3' ||this.tabname ==''">
                <!--   <div  class="card-header" style="padding:8px;position:relative">

                  {{form.mem_id}}({{form.mem_name}})
                 
              </div>  -->
                  <div>
                    <table class="table table-bordered layer-table" style="margin-bottom: 0rem;">
                      <thead>
                        <tr>
                          <th>누적 충전</th>
                          <th>누적 환전</th> 
                          <th>누적 충-환</th> 
                          <th>보유 머니</th> 
                          <th>보유 포인트</th>
                        </tr></thead>
                         <tbody>
                          <tr><td><span :class="func(form.in_money)">{{formatMoney(form.in_money)}}원</span></td> 
                              <td><span :class="func(form.out_money)">{{formatMoney(form.out_money)}}원</span></td> 
                              <td><span :class="func(form.pro_money)">{{formatMoney(form.pro_money)}}원</span></td> 
                              <td class="text-primary">{{formatMoney(form.mem_cash)}}원</td>
                              <td class="">{{formatMoney(form.mem_eventmoney)}}포인트</td>
                            </tr></tbody> 
                          </table>
                        </div>
                      </div>

                <el-tab-pane name="tab1">
                      <span slot="label"><i class="el-icon-user-solid"></i> {{$t('msg.회원정보')}}</span>

                
                    <div  class="card" style="margin-top: 5px;">
                  <div  class="card-header d-flex align-items-center" style="padding:0 8px">
                    <div>{{$t('msg.회원정보')}} : </div>
                    <div class="ml-1">
                       <template v-if="form.mem_lev<=6"><el-button type="text"   @click="openId(form.m_code,'tab1')"> {{form.m_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=5"><el-button type="text"   @click="openId(form.s_code,'tab1')">{{form.s_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=4"><el-button type="text"   @click="openId(form.b_code,'tab1')">{{form.b_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=3"><el-button type="text"   @click="openId(form.a_code,'tab1')"> {{form.a_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=2"><el-button type="text"   @click="openId(form.c_code,'tab1')"> {{form.c_code}} </el-button> >  </template>

                      

                      <template  v-for="(item,index) in form.memlist"  ><el-button  type="text"  @click="openId(item,'tab1')">{{item}}</el-button> > </template>


                      <template v-if="form.mem_lev==1"><el-button type="text"  @click="openId(form.mem_id,'tab1')">{{form.mem_id}}</el-button></template>
              
                    </div>
                    <div class="ml-auto">

              
                    </div>
                  </div> 
                  <div class="card-body" style="padding:10px;padding-bottom:0">
                    <el-form ref="form" :model="form" label-width="100px">
                        <table class="table  myTable1 ">
                            <tr>
                              <td width="50%">
                                 <el-form-item :label="$t('msg.아이디')" class="mb-0   layerItem">
                                    <div class="member-id-row">
                                      <el-input v-model="form.mem_id" disabled ></el-input>
                                      <span v-if="ulevel=='7' && formatMemberLevel(form.memState)" class="member-level">{{ formatMemberLevel(form.memState) }}</span>
                                    </div>
                                   
                                  </el-form-item>
                              </td>
                              <td >
                               <el-form-item :label="$t('msg.닉네임')" class="mb-0  layerItem">
                       
                                    <el-input v-model="form.mem_name"></el-input>
                                </el-form-item>
                              </td>
                            
                            </tr>
                           
                            <td>
                                 <el-form-item :label="$t('msg.비번')" class="mb-0   layerItem">
                                   <el-input v-model="form.mem_pw"></el-input>
                                  </el-form-item>
                              </td>
                               <td>
                                 <el-form-item label="계좌정보" class="mb-0   layerItem">
                                     <el-text>{{ form.mem_bankcode }}</el-text>
                                     <el-text>{{ form.mem_banknum }}</el-text>
                                     <el-text>{{ form.mem_bankname }}</el-text>
                                  </el-form-item>
                              </td>

                           
                            <tr>
                                <td>
                                   <el-form-item :label="$t('msg.가입일')" class="mb-0  layerItem">
                       
                                    <el-input v-model="form.mem_regdate" disabled></el-input>
                               </el-form-item>
                              </td>
                               <td>
                                 <el-form-item label="출생년월" class="mb-0 layerItem">
                                   <el-input v-model="form.mem_zip"></el-input>
                                 </el-form-item>
                              </td>
                             
                             
                            </tr>
                            <tr>
                             
                              <td>
                                   <el-form-item :label="$t('tableText.최종로그인')" class="mb-0   layerItem">
                                   <div class="d-flex align-items-center">
                                  <el-tag type="success">{{form.mem_login_date}}</el-tag>
                                  <span class="ml-2 mr-2" style="margin-top:1px">{{$t('msg.회차')}}</span> <el-tag type="danger">{{form.mem_login}}</el-tag>
                                 </div>
                                  </el-form-item>
                              </td>
                                <td>
                                  <el-form-item label="전화번호" class="mb-0 layerItem">
                                    <el-input v-model="form.mem_hp"></el-input>
                                  </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2">
                                <el-form-item class="mb-0 layerItem">
                                  <template slot="label">
                                    <div style="line-height:18px;">
                                      <div>화이트아이피</div>
                                      <el-popover
                                        placement="bottom-start"
                                        title="tips"
                                        trigger="click"
                                        content="여러아이피경우 띠여쓰기 또는 줄내림 또는 콤마로 연결해주세요">
                                        <el-button
                                          slot="reference"
                                          type="text"
                                          icon="el-icon-question"
                                          style="padding:0;">
                                        </el-button>
                                      </el-popover>
                                    </div>
                                  </template>
                                  <div style="color:#f56c6c; line-height:20px; margin-bottom:5px;">
                                    <div>화이트 IP 미설정 시 모든 IP에서 로그인이 허용됩니다.</div>
                                    <div>화이트 IP 설정 시 등록된 IP에서만 로그인이 허용됩니다.</div>
                                  </div>
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    v-model="form.whitelist">
                                  </el-input>
                                </el-form-item>
                              </td>
                            </tr>
                             
                        </table>
                    </el-form>
                  </div>
                </div>
          <div class="d-flex" style="justify-content: right;margin-top: 5px;">
               <el-button type="primary" @click="Save" :disabled="disabled">{{$t('msg.수정')}}</el-button>
                <el-button @click="Cancel">Close</el-button>
          </div>


                </el-tab-pane>
                

                  <el-tab-pane   name="tab3">
                     <span slot="label"><i class="el-icon-user-solid"></i> {{$t('searchText.요율')}}</span>
                     
                   <div  class="card" style="margin-top: 5px;">
                  <div  class="card-header">{{$t('searchText.요율')}}</div> 

                  <div class="card-body" style="padding:10px">
                    <el-form ref="form" :model="form" label-width="150px">
                        <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code || form.mem_id===form.s_code || form.mem_id===form.m_code">
                        <table class="table  myTable1 ">
                            <tr>
                              <td width="50%">
                                 <el-form-item :label="$t('msg.카지노')" class="mb-0   layerItem">
                                    <el-input v-model="form.event_loing_recom_e" class="w-75">
                                        <template slot="append">%</template>
                                    </el-input>
                                  
                                  </el-form-item>
                              </td>
                              <td>
                                <el-form-item :label="$t('msg.슬롯')" class="mb-0   layerItem">
                                   <el-input v-model="form.event_loing_recom_slot" class="w-75">
                                     <template slot="append">%</template>
                                   </el-input>
                                   
                                  </el-form-item>
                              </td>
                               
                            </tr>
                           
                           
                             <tr>
                            <td>
                                  <el-form-item v-if="this.power=='1'" :label="$t('msg.파워볼일반')" class="mb-0   layerItem">
                                    
                                    <el-input v-model="form.event_loing" class="w-75">
                                        <template slot="append">%</template>
                                    </el-input>
                                  
                                  </el-form-item>
                              </td>
                              <td >
                                <el-form-item v-if="this.power=='1'" :label="$t('msg.파워볼조합')" class="mb-0   layerItem">
                                   
                                   <el-input v-model="form.event_loing_group" class="w-75">
                                     <template slot="append">%</template>
                                   </el-input>
                                   
                                  </el-form-item>
                              </td>
                              
                            </tr>
                        </table>
                        </template>
                        <template v-else="">
                        <table class="table  myTable1 " >
                            <tr>
                              <td width="50%">
                                 <el-form-item :label="$t('msg.카지노')" class="mb-0   layerItem">
                                    <el-input v-model="form.event_loing_e" class="w-75">
                                        <template slot="append">%</template>
                                    </el-input>
                                  
                                  </el-form-item>
                              </td>
                              <td>
                                <el-form-item :label="$t('msg.슬롯')" class="mb-0   layerItem">
                                   <el-input v-model="form.event_loing_slot" class="w-75">
                                     <template slot="append">%</template>
                                   </el-input>
                                   
                                  </el-form-item>
                              </td>
                              
                            </tr>
                          
                           
                        
                               <tr>
                              <td>
                                <el-form-item v-if="this.power=='1'" :label="$t('msg.파워볼일반')" class="mb-0   layerItem">
                                    
                                    <el-input v-model="form.event_loing" class="w-75">
                                        <template slot="append">%</template>
                                    </el-input>
                                  
                                  </el-form-item>
                              </td>
                              <td>
                                <el-form-item v-if="this.power=='1'" :label="$t('msg.파워볼조합')" class="mb-0   layerItem">
                                   
                                   <el-input v-model="form.event_loing_group" class="w-75">
                                     <template slot="append">%</template>
                                   </el-input>
                                   
                                  </el-form-item>
                              </td>
                                 
                            </tr>
                        </table>
                        </template>
                    </el-form>
                  </div>
                </div>
                 <div class="d-flex" style="justify-content: right;margin-top: 5px;">
               <el-button type="primary" @click="Save" :disabled="disabled">{{$t('msg.수정')}}</el-button>
             
                <el-button @click="Cancel">Close</el-button>
          </div>
                  </el-tab-pane>

                 
    <el-tab-pane  name="tab4">
                     <span slot="label"><i class="el-icon-close"></i> {{$t('tableText.내손익')}}</span>
                     <div  class="" >
                  <!-- <div  class="card-header"> {{$t('tableText.내손익')}}</div>  -->
                  <div class="" >
                      <el-tabs v-model="activeName7" @tab-click="handleClick7" type="card" class="mt-2">
      
                       <el-tab-pane  name="tab7-1">
                         <span slot="label">{{$t('msg.전체')}}</span>
                           <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time7"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent7" :loading="sLoading7">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                border
               height="430"
                :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading7"
                show-summary
       :summary-method="getSummaries" class="memlistTable" ref="table">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt1)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt2)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt12)">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


       <el-table-column 
        :label="$t('msg.총배팅')" prop="tt5" width=120 align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt5)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5ca)}}</template>
      </el-table-column>
      <el-table-column 
         :label="$t('msg.총배팅슬')" prop="tt5st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5st)}}</template>
      </el-table-column>
    
      <el-table-column 
        :label="$t('msg.총배팅파')" v-if="this.power=='1'"  prop="tt5pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5pa)}}</template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총당첨')" prop="tt6" width=120 align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt6)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6ca)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6st)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨파')" v-if="this.power=='1'" prop="tt6pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6pa)}}</template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총수수료')" prop="tt7" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt7)}}</span></template>
      </el-table-column>

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7ca)}}</template>
      </el-table-column>

      <el-table-column
        :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7st)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총수수료파')" v-if="this.power=='1'" prop="tt7pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7pa)}}</template>
      </el-table-column>

       <el-table-column 
        :label="$t('msg.총수익')" prop="tt567" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt567)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567ca)}}</template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567st)}}</template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익파')" v-if="this.power=='1'" prop="tt567pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567pa)}}</template>
      </el-table-column>


        
  
     
    </el-table>
                       </el-tab-pane>
                        <el-tab-pane  name="tab7-2">
                         <span slot="label">{{$t('msg.카지노')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time7"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent7" :loading="sLoading7">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                 height="430"
                border
                style="width: 100%;" v-loading="loading7"
                show-summary
       :summary-method="getSummaries" class="memlistTable" ref="table2">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5ca)}}</template>
      </el-table-column>
     
    
   

    
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6ca)}}</template>
      </el-table-column>
 
  

     

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7ca)}}</template>
      </el-table-column>

  
     

     

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567ca)}}</template>
      </el-table-column>
     
     


        
  
     
    </el-table>
                       </el-tab-pane>
                        <el-tab-pane  name="tab7-3">
                         <span slot="label">{{$t('msg.슬롯')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time7"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent7" :loading="sLoading7">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                border
                 height="430"
                 ref="table3"
                style="width: 100%;" v-loading="loading7"
                show-summary
       :summary-method="getSummaries" class="memlistTable" >
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     
  
      <el-table-column 
         :label="$t('msg.총배팅슬')" prop="tt5st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5st)}}</template>
      </el-table-column>
    
   

     
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6st)}}</template>
      </el-table-column>
    

      

      <el-table-column
        :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7st)}}</template>
      </el-table-column>
      
 

      
      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567st)}}</template>
      </el-table-column>
    


        
  
     
    </el-table>
                       </el-tab-pane>
                     </el-tabs>
                 
              
            
                  </div>
                </div>
                
                  </el-tab-pane>
                  <el-tab-pane  name="tab48">
                     <span slot="label"><i class="el-icon-close"></i> {{$t('newAdd.월정산')}}</span>
                     <div  class="">
                  <!-- <div  class="card-header">{{$t('newAdd.월별종합현황')}}</div>  -->
                  <div class="" style="">
                      <el-tabs v-model="activeName8" @tab-click="handleClick8" type="card" class="mt-2">
      
                       <el-tab-pane  name="tab8-1">
                         <span slot="label">{{$t('msg.전체')}}</span>
                           <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time8"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent8" :loading="sLoading8">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                 height="430"
                border
                ref="table4"
                :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading8"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt1)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt2)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt12)">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


       <el-table-column 
        :label="$t('msg.총배팅')" prop="tt5" width=120 align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt5)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5ca)}}</template>
      </el-table-column>
      <el-table-column 
         :label="$t('msg.총배팅슬')" prop="tt5st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5st)}}</template>
      </el-table-column>
    
      <el-table-column 
        :label="$t('msg.총배팅파')" v-if="this.power=='1'"  prop="tt5pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5pa)}}</template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총당첨')" prop="tt6" width=120 align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt6)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6ca)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6st)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨파')" v-if="this.power=='1'" prop="tt6pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6pa)}}</template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총수수료')" prop="tt7" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt7)}}</span></template>
      </el-table-column>

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7ca)}}</template>
      </el-table-column>

      <el-table-column
        :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7st)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총수수료파')" v-if="this.power=='1'" prop="tt7pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7pa)}}</template>
      </el-table-column>

       <el-table-column 
        :label="$t('msg.총수익')" prop="tt567" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt567)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567ca)}}</template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567st)}}</template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익파')" v-if="this.power=='1'" prop="tt567pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567pa)}}</template>
      </el-table-column>


        
  
     
    </el-table>
                       </el-tab-pane>
                        <el-tab-pane  name="tab8-2">
                         <span slot="label">{{$t('msg.카지노')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time8"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent8" :loading="sLoading8">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                border
                 height="430"
                 ref="table5"
                style="width: 100%;" v-loading="loading8"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5ca)}}</template>
      </el-table-column>
     
    
   

    
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6ca)}}</template>
      </el-table-column>
 
  

     

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7ca)}}</template>
      </el-table-column>

  
     

     

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567ca)}}</template>
      </el-table-column>
     
     


        
  
     
    </el-table>
                       </el-tab-pane>
                        <el-tab-pane  name="tab8-3">
                         <span slot="label">{{$t('msg.슬롯')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time8"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent8" :loading="sLoading8">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                border
                 height="430"
                 ref="table6"
                style="width: 100%;" v-loading="loading8"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     
  
      <el-table-column 
         :label="$t('msg.총배팅슬')" prop="tt5st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5st)}}</template>
      </el-table-column>
    
   

     
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6st)}}</template>
      </el-table-column>
    

      

      <el-table-column
        :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7st)}}</template>
      </el-table-column>
      
 

      
      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567st)}}</template>
      </el-table-column>
    


        
  
     
    </el-table>
                       </el-tab-pane>
                     </el-tabs>
                 
              
            
                  </div>
                </div>
                
                  </el-tab-pane>




  <el-tab-pane v-if="this.ulevel=='3' || this.money_inout=='1'"   name="tab6">
                     <span slot="label"><i class="el-icon-info"></i> {{$t('newAdd.머니')}}</span>
                     <div  class="row mt-2">
                        <div  class="col-sm-6">
                          <div  class="card">
                            <div  class="card-header" style="padding:3px 5px;">{{$t('newAdd.머니지급')}}</div> 
                            <div  class="card-body" style="padding:5px">
                               <el-form ref="bonForm" :model="bonForm" label-width="150px" v-loading="layLoading"  :rules="rules">
                        <table class="table  myTable2" style="margin-bottom:0">
                            <tr>
                              <td >
                                 <el-form-item :label="$t('newAdd.처리사유')" class="mb-0   layerItem">
                                    <el-input class="w-75" :placeholder="$t('newAdd.처리사유')"  v-model="bonForm.memo1"></el-input>
                                  
                                  </el-form-item>
                              </td>
                             
                            </tr>
                              <tr>
                              <td >
                                 <el-form-item :label="$t('tableText.금액')" class="mb-0   layerItem"  prop="money1">
                                    <el-input  class="w-75" :placeholder="$t('tableText.금액')" v-model="bonForm.money1" type="number"></el-input>
                                  
                                  </el-form-item>
                              </td>
                            
                             
                            </tr>
                            <tr>
                                <td align="center">
                               
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal('10000')">1{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(50000)">5{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(100000)">10{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(500000)">50{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(1000000)">100{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(0)">{{$t('tableText.정정')}}</el-button>
          
                              </td>
                            </tr>
                            <tr>
                              <td align="center" style="padding-top:5px"> 
                               <el-button type="danger" size="mini"  @click="cash_input('1')"  icon="el-icon-plus">{{$t('newAdd.머니지급')}}</el-button> 
                               <el-button type="success" size="mini"  @click="cash_input('2')"  icon="el-icon-minus">{{$t('newAdd.머니차감')}}</el-button>
                              </td>
                             
                            </tr>
        
                        </table>
                    </el-form>
                            </div>
                          </div>
                        </div> 
                        
                      </div>
                      <el-tabs v-model="activeName" @tab-click="handleClick" type="card" class="mt-2">
      
                       <el-tab-pane  name="tab6-1">
                         <span slot="label"><i class="el-icon-money"></i>{{$t('newAdd.머니변동')}}</span>
                           <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd"  style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                        <el-form-item class="mb-0 mr-0">
                          <div class="d-flex align-items-center">
                          <span class="mr-1">수동지급</span>
                      <el-switch
                          v-model="admin_in" 
                           :active-value="1"
                           :inactive-value="0"
                          active-color="#13ce66"
                          inactive-color="#cfcdcd">
                        </el-switch>
                         <span class="mr-1 ml-1">수동차감</span>
                       <el-switch
                          v-model="admin_out"
                          :active-value="1"
                           :inactive-value="0"
                          active-color="#13ce66"
                          inactive-color="#cfcdcd">
                        </el-switch>
                      </div>
                     

                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent5" :loading="sLoading5" class="ml-2">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                     <!-- <span class="ml-2">{{$t('searchText.알충')}}:{{formatMoney(ain)}} </span>
                   <span class="ml-2 mr-2">{{$t('searchText.알환')}}:{{formatMoney(aout)}}</span>
                   <span>{{$t('searchText.차액')}}:{{formatMoney(ain+aout)}}</span>-->
                   
       
    
                </div>
                      <el-table
                :data="tabList"
                 border
                  :row-class-name="tableRowClassName"
                style="width: 100%" v-loading="loading5">
                
                <el-table-column
                :label="$t('nav.아이디')"
                  width=100 align="center" prop="mem_id">
                   <template slot-scope="scope"> <el-button @click="del_id(scope.row.id)" type="text" style="padding:2px">{{scope.row.mem_id}}</el-button></template>
                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.금액')" 
                  align="center" prop="money">
                   <template slot-scope="scope"><span :class="scope.row.money <0 ?'text-danger':'text-success'">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

              

                <el-table-column
                :label="$t('tableText.잔액')"
               align="center" prop="new_money">

                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.new_money)}}</span></template>
                   
                </el-table-column>

                   <el-table-column
                 :label="$t('msg.내용')" width="300"
                   align="center" prop="doc">

                       <template slot-scope="scope"><span>{{ scope.row.doc}} {{ scope.row.memo}}</span></template>

                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')"
                  >
                  
                </el-table-column>
                  
               
              
              </el-table>
               <div style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange5">
                </el-pagination>
                </div>
                       </el-tab-pane>
                       <el-tab-pane  name="tab6-2">
                          <span slot="label"><i class="el-icon-coin"></i>{{$t('newAdd.포인트변동')}}</span>
                          <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd"  style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                       <el-form-item class="mb-0 mr-0">
                          <div class="d-flex align-items-center">
                          <span class="mr-1">관리자 지급</span>
                      <el-switch
                          v-model="admin_in"
                          :active-value="1"
                           :inactive-value="0"
                          active-color="#13ce66"
                          inactive-color="#cfcdcd">
                        </el-switch>
                        <span class="mr-1 ml-1">관리자 차감</span>
                       <el-switch
                          v-model="admin_out"
                          :active-value="1"
                           :inactive-value="0"
                          active-color="#13ce66"
                          inactive-color="#cfcdcd">
                        </el-switch>
                          <span class="mr-1 ml-1">포인트 전환</span>
                        <el-switch
                          v-model="point_trans"
                           :active-value="1"
                           :inactive-value="0"
                          active-color="#13ce66"
                          inactive-color="#cfcdcd">
                        </el-switch>
                      </div>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent5" :loading="sLoading5" class="ml-2">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                   
       
    
                </div>
                      <el-table
                :data="tabList"
                 border
                  :row-class-name="tableRowClassName"
                style="width: 100%" v-loading="loading5">
                
                <el-table-column
                :label="$t('nav.아이디')"
                  width=100 align="center" prop="mem_id">
                   <template slot-scope="scope"><el-button @click="del_id(scope.row.id)" type="text" style="padding:2px">{{scope.row.mem_id}}</el-button></template>
                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.금액')" 
                  align="center" prop="money">
                   <template slot-scope="scope"><span :class="scope.row.money <0 ?'text-danger':'text-success'">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                

                <el-table-column
                :label="$t('tableText.잔액')"
               align="center" prop="new_event">

                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.new_event)}}</span></template>
                   
                </el-table-column>


                 <el-table-column
                  :label="$t('tableText.베팅금액')" 
                  align="center" prop="point">
                   <template slot-scope="scope">{{ formatMoney(scope.row.point)}}</template>
                </el-table-column>

              <el-table-column
                 :label="$t('msg.내용')" 
                   align="center" prop="" width="300">
                       <template slot-scope="scope">{{ scope.row.doc}}</template>

                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')"
                  >
                  
                </el-table-column>
                  
               
              
              </el-table>
               <div style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange5">
                </el-pagination>
                </div>
                       </el-tab-pane>
                       <el-tab-pane  name="tab6-4">
                          <span slot="label"><i class="el-icon-coin"></i>{{$t('tableText.알충환')}}</span>
                          <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                      <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value3"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                     
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd"  style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent5">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                   <span class="ml-2">{{$t('searchText.알충')}}:{{formatMoney(ain)}} </span>
                   <span class="ml-2 mr-2">{{$t('searchText.알환')}}:{{formatMoney(aout)}}</span>
                   <span>{{$t('searchText.차액')}}:{{formatMoney(ain+aout)}}</span>
       
    
                </div>
                      <el-table
                :data="tabList"
                 border
                  :row-class-name="tableRowClassName"
                style="width: 100%" v-loading="loading5">
                
                <el-table-column
                :label="$t('nav.아이디')"
                  width=100 align="center" prop="mem_id">
                   <template slot-scope="scope"> <el-button @click="del_id(scope.row.id)" type="text" style="padding:2px">{{scope.row.mem_id}}</el-button></template>
                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.금액')" 
                  align="center" prop="money">
                   <template slot-scope="scope"><span :class="scope.row.money <0 ?'text-danger':'text-success'">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                 <el-table-column
                 :label="$t('msg.내용')" 
                   align="center" prop="doc">
                </el-table-column>

                <el-table-column
                :label="$t('tableText.잔액')"
               align="center" prop="new_money">

                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.new_money)}}</span></template>
                   
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')"
                  >
                  
                </el-table-column>
                  
               
              
              </el-table>
                <div style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange">
                </el-pagination>
                </div>  
                        </el-tab-pane>
                      </el-tabs>
                   
                  </el-tab-pane>

                 
                   <el-tab-pane  name="tab5">
                       <span slot="label"><i class="el-icon-s-order"></i> {{$t('msg.베팅내역')}}</span>
                    
                    <div  class="card" style="margin-top: 5px;">
                  <div  class="card-header">{{$t('msg.베팅내역')}}</div> 
                  <div class="card-body" style="padding:10px">
                    <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd  HH:mm:ss" style="width:300px"  :default-time="['00:00:00','23:59:59']">
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                         <el-select v-model="provider_name"  style="width: 150px;" class="ml-2 mr-2" size="mini" filterable >
                           <el-option
                                  v-for="item in providerlist"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                         <span class="mr-1 ml-1">하부포함</span>
                          <el-checkbox true-label="1" false-label="0" v-model="habu"></el-checkbox>
                        <el-button type="info" size="mini" @click="idsearchEvent4" :loading="sLoading4">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>

                   <div v-if="this.form.sitetype=='4'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>({{$t('msg.카')}}:{{formatMoney(total_money_e)}} {{$t('nav.슬')}}:{{formatMoney(total_money_slot)}})|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>({{$t('msg.카')}}:{{formatMoney(total_emoney_e)}} {{$t('nav.슬')}}:{{formatMoney(total_emoney_slot)}})|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}}</span></div>

                   <div v-if="this.form.sitetype=='2'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}}</span></div>
       
    
                </div>

                  <template v-if="this.form.sitetype=='4'">
                      <el-table

                :data="tabList"
                 border
                   @sort-change='tableSortChange'
                  :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading4">
               
                <el-table-column
                  :label="$t('nav.게임사')" align="center"  prop="provider_name">
                </el-table-column>
                 
                  <el-table-column
                  :label="$t('tableText.게임명')"
                   align="center" prop="game_title">
                </el-table-column>
                

              

                 <el-table-column
                  prop="tx_type" align="center" width=40
                  :label="$t('searchText.구분')">  
                </el-table-column>

                   <el-table-column
                  prop="bet" align="center" width=100
                  :label="$t('nav.배팅')" sortable="custom">
                   <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.bet)}}</span></template>
                </el-table-column>
                <el-table-column
                  prop="win" align="center" width=100
                  :label="$t('msg.당첨')" sortable="custom">
                    <template slot-scope="scope"><span class="text-success">{{ formatMoney(scope.row.win)}}</span></template>
                </el-table-column>
                <el-table-column
                  prop="balance" align="center"
                  :label="$t('msg.잔고')">
                   <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.balance)}}</span></template>
                </el-table-column>


                
                <el-table-column
                  prop="create_at" align="center" 
                  :label="$t('msg.일시')" sortable="custom">
                </el-table-column>
                <el-table-column
                  prop="txid" align="center"  width=70
                  :label="$t('msg.상세')">
                   <template slot-scope="scope">
        
                          <el-button type="primary" size="mini" @click="linkBtn(scope)" plain style="padding:2px;">{{$t('msg.상세보기')}}</el-button>
 
                  </template>
                </el-table-column> 
              </el-table>

            </template>

                <template v-if="this.form.sitetype=='1'">
                                <el-table
                          :data="tabList"
                           @sort-change='tableSortChange'
                           border
                  :row-class-name="tableRowClassName"
                          style="width: 100%;"  v-loading="loading4">
                         
                          <el-table-column
                           :label="$t('msg.회차')"
                           align="center"  prop="buy_num">
                          </el-table-column>
                           
                            <el-table-column
                             :label="$t('searchText.구분')"
                            align="center" prop="buy_gubun">
                          </el-table-column>
                          

                          <el-table-column
                            prop="buy_money" align="center"
                             :label="$t('nav.배팅')" 
                            >

                             <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.buy_money)}}</span></template>

                          </el-table-column>

                           <el-table-column
                            prop="buy_bedang" align="center"
                             :label="$t('msg.배당')" sortable="custom"
                           >  
                          </el-table-column>

                           <el-table-column
                            prop="buy_emoney" align="center"
                             :label="$t('msg.당첨')" sortable="custom"> 
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.buy_emoney)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="ocs" align="center"
                             :label="$t('tableText.이전잔액')"
                           >
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.ocs)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="c_m" align="center"
                            :label="$t('msg.이전롤링')" >
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.c_m)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="buy_time" align="center" 
                             :label="$t('msg.일시')" sortable="custom">
                          </el-table-column>
                          
                        </el-table>
                        </template>
                  </div>
                  </div>    
                    <div v-if="tapId !=='0'" style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange">
                </el-pagination>
                </div>  
                   
                  </el-tab-pane>
                   
              </el-tabs>
             
           <!--   <div v-if="tapId =='3'" style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange">
                </el-pagination>
                </div>-->
         
        <el-dialog
            :visible.sync="dialogVisible" :width="getW" class="idModel" :modal="modelFalse"  top="5vh" >
            <div class="border-bottom py-3"><span class="text-danger" style="font-size:16px">{{this.form.mem_id}} ({{this.form.mem_name}})</span></div>
            <el-table
                :data="memIdData"
                style="width: 100%" v-loading="loading" class="memTable">
                <el-table-column
                  prop="date"
                  :label="$t('msg.날자')"
                  
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="inm"
                  :label="$t('msg.입금')"
                  >
                  <template slot-scope="scope">
                     {{formatMoney(scope.row.inm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="outm"
                  :label="$t('msg.출금')"
                  >
                   <template slot-scope="scope">
                     {{formatMoney(scope.row.outm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="inm"
                  :label="$t('searchText.차액')"
                  >
                  <template slot-scope="scope">
                     <span :class="scope.row.inm - scope.row.outm <0 ?'text-danger':'text-primary'">{{formatMoney(scope.row.inm - scope.row.outm)}}</span>
                  </template>
                </el-table-column>
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">Close</el-button>
        
            </span>
          </el-dialog>
          <el-dialog
          :width="autoqaWidth"
          :title="$t('searchText.쪽지보내기')"
          top="6vh"
          :visible.sync="creatModel" class=""
          :modal="modelFalse"
          :close-on-click-modal ="false">
          <div class="d-flex" v-loading="qaLoading">
          <div style="width:73%">
          <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
            <div style="padding-left:100px" class="text-danger mb-1">
              1. {{$t('msg.아이디만입력시해당아이디로만전송')}}<br>2. {{$t('msg.아이디입력및부본총판매장선택시해당소속회원까지전송')}}<br>3. {{$t('msg.아이디없이레벨만선택시해당등급에만전송')}}
            </div>
            <el-form-item class="mb-1" :label="$t('nav.아이디')" prop="mem_id">
              <el-input v-model="form.mem_id"></el-input>
            </el-form-item>
            
            <el-form-item class="mb-1" :label="$t('searchText.구분')">
          <!--<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-right: 10px;">ALL</el-checkbox>-->
                 
                  <el-checkbox-group v-model="gubun" @change="handlelevelChange">
                    <el-checkbox v-for="checkboxs in level_opt" :label="checkboxs.label" :key="checkboxs.value" style="margin-right: 10px;">{{checkboxs.label}}</el-checkbox>
                  </el-checkbox-group>
            </el-form-item>
             <el-form-item class="mb-1" :label="$t('msg.레벨')">
         
              
                  <el-checkbox-group v-model="level" @change="handlelevelChange">
                    <el-checkbox v-for="checkboxs1 in level_opt1" :label="checkboxs1.label" :key="checkboxs1.value"  style="margin-right: 10px;">{{checkboxs1.label}}</el-checkbox>
                  </el-checkbox-group>
            </el-form-item>
           <el-form-item class="mb-1" :label="$t('msg.내용')" prop="wr_1">
              
               <el-input
            type="textarea"
            :rows="6"
            v-model="wr_1">
          </el-input>
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false" style="float:right;">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="memoSend()" style="float:right;" class="mr-2">{{$t('msg.확인')}}</el-button>
          </span>
        </div>
        <div class="border ml-auto p-2 d-flex" style="width:25%;flex-direction:column;align-items:start;height:400px;overflow-y:auto;">
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title2}}</el-button>
          
          </div>
      </div>
        
       
       
        </el-dialog>
          <el-dialog
          :width="memWidth"
          :title="$t('msg.추천내역')" :modal="modelFalse"
          :visible.sync="reComModel"  top="5vh">
           <el-table
                :data="reComData"
                style="width: 100%" v-loading="loading">
                <el-table-column
                  prop="mem_id"
                   :label="$t('msg.아이디닉네임')"
                  width="180">
                   <template slot-scope="scope">{{scope.row.mem_id}}({{scope.row.mem_name}}) {{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}}</template>
                </el-table-column>
                
                <el-table-column
                  prop="mem_regdate"
                   :label="$t('msg.가입일')">
                  
                </el-table-column>
             
              </el-table>

         
          <span slot="footer" class="dialog-footer">
             <el-button @click="reComModel = false">{{$t('msg.닫기')}}</el-button>
          
          </span>
        
       
       
        </el-dialog>
         <el-dialog
          :width="autoqaWidth"
          :title="$t('newAdd.쪽지매크로관리')" :modal="modelFalse"
          :visible.sync="autoqaModel"  top="6vh" class="idModel">
          <div class="mb-2 d-flex">
            <el-form inline ref="form" :model="searchform">

               
                    <el-form-item class="mb-0">
                         <el-input :placeholder="$t('searchText.키워드')"  v-model="searchform.keyword" size="mini" style="width:200px" ></el-input>
                    </el-form-item>
                  
                    <el-form-item class="mb-0" >
                        <el-button type="info" size="mini" @click="searchQaEvent">{{$t('searchText.검색')}}</el-button>
                        <el-button type="success" size="mini" @click="editCon(false)">{{$t('tableText.추가')}}</el-button> 
                    </el-form-item>
            </el-form>
          
       
         
        
            
            
        </div>
           <el-table
                :data="autoQaContent"
                style="width: 100%" v-loading="autoqaLoading" class="autoTable">
                <el-table-column
                  prop="title"
                   :label="$t('msg.제목')"
                 >
                   <template slot-scope="scope">{{scope.row.title}}</template>
                </el-table-column>
                
                <el-table-column
                  prop="add_time"
                   :label="$t('msg.등록일')" width="150">
                  
                </el-table-column>
              <el-table-column :label="$t('newAdd.관리')" align="center" class="mybuttonmini" width="200">
                             <template slot-scope="scope">
                            
                               
                                    <el-button type="primary" icon="el-icon-edit" size="mini" @click="editCon(scope)">{{$t('msg.수정')}}</el-button>
                                
                                    <el-button type="danger" icon="el-icon-delete" size="mini" @click="del_qa_idx(scope.row.id)">{{$t('msg.삭제')}}</el-button>
                            
                          </template>
        </el-table-column>
              </el-table>

         
          <span slot="footer" class="dialog-footer">
             <el-button @click="autoqaModel = false">{{$t('msg.닫기')}}</el-button>
          
          </span>
        
       
       
        </el-dialog>
          <el-dialog
         :title="this.editIndex===-1 ? $t('tableText.추가') :$t('status.편집')"
          :visible.sync="autocreatModel" :close-on-click-modal ="false" :width="getW" :modal="modelFalse" top="5vh" class="quillDialog">

          <el-form ref="form" :model="form" label-width="70px" v-loading="autoloading" :rules="rules">
            
            <el-form-item :label="$t('searchText.키워드')"  prop="title2" class="mb-1">
              <el-input v-model="autoForm.title2" :placeholder="$t('searchText.리스트에노출될키워드')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.제목')" prop="title" class="mb-1">
              <el-input v-model="autoForm.title" :placeholder="$t('msg.답변제목')"></el-input>
            </el-form-item>
           <el-form-item :label="$t('msg.내용')"  prop="contents" class="mb-1">
            <!--    <el-input
                type="textarea"
                :rows="12"
                v-model="form.contents" :placeholder="$t('msg.답변내용')">
              </el-input> -->
               <quill-editor 
                                v-model="autoForm.contents" 
                                ref="myQuillEditor" 
                                :options="editorOption" 
                                @blur="onEditorBlur($event)" 
                                @focus="onEditorFocus($event)"
                              @change="onEditorChange($event)">
                      </quill-editor>
                      <input type="file" @change="change" id="upload" style="display:none;" />
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="autocreatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="autoSubmit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>    
          <el-dialog
          :title="$t('newAdd.게임사충환')"
          :visible.sync="mtcreatModel" :modal="modelFalse"  :width="getW">
           <el-table
                :data="kennData"
                style="" v-loading="mtLoad">
                <el-table-column
                  prop="username"
                   :label="$t('msg.아이디')"
                  width="" align="center">
                   
                </el-table-column>
                 <el-table-column
                  prop="amount"
                   :label="$t('tableText.금액')" align="center">
                    <template slot-scope="scope">
                    {{formatMoney(scope.row.amount)}}
                  </template>
                </el-table-column>
                 <el-table-column
                  prop="after"
                   :label="$t('tableText.잔액')" align="center">
                    <template slot-scope="scope">
                    {{formatMoney(scope.row.after)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="create_at"
                   :label="$t('tableText.시간')" align="center"  width="180">
                  
                </el-table-column>
              <el-table-column
                  prop="type"
                   :label="$t('searchText.구분')" align="center">
                    <template slot-scope="scope">
                   {{ktypeObj[scope.row.type]}}
                  </template>
                </el-table-column>
              </el-table>

        
          <span slot="footer" class="dialog-footer">
             <el-button @click="mtcreatModel = false">{{$t('msg.닫기')}}</el-button>
          
          </span>
        
       
       
        </el-dialog>
          <el-dialog
  
          :visible.sync="getModel" :modal="modelFalse"  :width="getW">
          
          <el-form ref="getform" :model="getform" v-loading="loading">
            <div class="d-flex">
               <div class="boxflex">
                   <h2>{{$t('msg.알잔액')}}</h2>
                   <p id="sitem">{{formatMoney(sitem)}} </p>
               </div>
               <div class="boxflex">
                   <h2>{{$t('msg.카슬머니')}}</h2>
                   <p id="apim">{{formatMoney(apim)}} </p>
               </div>
           </div>
            <div class="d-flex" style="width: 600px;">
               <el-form-item>
              <el-input v-model="getform.site_cash" size="mini" style="width: 100px;"></el-input>
            </el-form-item>
            <el-form-item class="getItem mb-0 ml-2">
               <el-select v-model="getvalue" size="mini" style="width:140px;" @change="getChange($event,1)">
               <el-option
                      v-for="item in getOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
             
           
            <el-form-item class="getItem mb-0 ml-2">
              <span>-></span>
               <el-select v-model="getapim" size="mini" style="width:140px;" @change="getChange($event,2)">
               <el-option
                      v-for="item in getOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="getItem mb-0 ml-2">
              <el-button type="primary" size="mini" @click="submitGetm" :disabled="disabled">{{$t('msg.전환하기')}}</el-button>
            </el-form-item>
          </div>
          </el-form>
         
       
        </el-dialog>
  </div>
</template>
<script>
 import { quillEditor, Quill  } from "vue-quill-editor";
Quill.register('modules/ImageExtend', ImageExtend)
import {ImageExtend, QuillWatch } from "quill-image-extend-module"
import "quill/dist/quill.core.css"; 
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
  import transaction from './transaction.vue';
import EventBus from '../../assets/js/eventBus.js';
import bettingDetails from './betting-details.vue';
import holdem from './holdem.vue';
 import layerchildnew from './layer-child-new.vue';
 import layerNew from './layer-new.vue';
 import layoutLayer from './layout-layer.vue';
 import wrDialog from './wr-dialog.vue';
 import coupon from './coupon.vue';
const checkboxsOptions = ['0', '1', '2', '3', '4', '5', '6', '7'];


  export default{
    components: {
    
      layerchildnew,layoutLayer,transaction,bettingDetails,holdem,coupon,layerNew,quillEditor,wrDialog
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
      activeTab:{
        type:String,
        default:""
      },
       model:{
        type:Boolean,
        default:false,
      },
      lydata:{
        type:Object,
        default:()=>{
          return {}
        }
      },

      
      visible: {
                type: Boolean,
                default: false
            },
  
    formobject: {
        type: Object,
        default: () => {}
    },
   
    
    },

      data(){
        return{
        
             editorOption: {
           
            modules:{
            
              toolbar: {
                container:[
                     ['bold', 'italic', 'underline', 'strike'],  
                   
                     [{'list': 'ordered'}, {'list': 'bullet'}], 
                     ["image",'video','link'],
                     [{'color': []}, {'background': []}],
                    
                     [{'header': [1, 2, 3, 4, 5, 6, false]}],
                     
                ],
                 handlers: {
                    image(value) {
                      if (value) {
                        
                        document.querySelector('#upload').click()
                      } else {
                        this.quill.format('image', false)
                      }
                    },
                  },

              },
            },
             
            },
             habu:'1',
            prop:'',
            order:'',
            modelpop:this.model,
            bonForm:{
            all:false,
           
            mem_id:'',
            money1:'',
            memo1:'',
            code:'',
          },
          bonForm1:{
            all:false,           
            mem_id:'',           
            money2:'',           
            memo2:'',
            code:'',
          },
          layLoading:false,
          layoutLoad:false,
          layLoading1:false,
            autoForm:{
              title2:'',
              title:'',
              contents:'',
              id:'',
             },
            autocreatModel:false,
             layerOptions:[
            {
              label:this.$i18n.t("msg.전체"),
              value:'1011'
            },
            {
              label:this.$i18n.t("msg.알충"),
              value:'10'
            },
            {
              label:this.$i18n.t("msg.알환"),
              value:'11'
            },
           
            ],
             layerValue:'',
          kennData:[],
          ktypeObj:{
            'add':this.$i18n.t("msg.충전"), 
            'sub':this.$i18n.t("msg.환전"), 
          },
            typeObj:{
              
              '1':this.$i18n.t("msg.배팅"), 
               '7':this.$i18n.t("msg.당첨"),
              '2':this.$i18n.t("msg.입금"),
              '3':this.$i18n.t("msg.출금"),
              '4':this.$i18n.t("msg.롤링전환"),
              '5':this.$i18n.t("msg.롤링지급"),
               '12':this.$i18n.t("msg.매장롤링"),
              '6':this.$i18n.t("msg.총판롤링"),
              '8':this.$i18n.t("msg.부본사롤링"),
              '9':this.$i18n.t("msg.회원롤링"),
              '10':this.$i18n.t("msg.알충전"),
              '11':this.$i18n.t("msg.알환전"),

               '13':this.$i18n.t("msg.롤링충전"),
              '14':this.$i18n.t("msg.롤링환전"),
             
              '21':this.$i18n.t("msg.사이트머니카지노머니전환"),
              '22':this.$i18n.t("msg.카지노머니사이트머니전환"),
 
            },
          total_emoney_e:'',
          total_emoney_slot:'',
           total_emoney:'',
          total_money:'',
           total_money_e:'',
          total_money_slot:'',
          total_rog:'',
           total_money_d:'',
            total_money_z:'',
             total_emoney_d:'',
              total_emoney_z:'',
              money:'',
              add_time:'',

           ain:'',
            aout:'',
             providerlist:[
            {
                label:this.$i18n.t("status.선택"),
                value:''
            },
            ],
          provider_name:'',
            autoqaWidth:'800px',
           getW:'600px',
           mtLoad:false,
           sLoading:false,
           loading5:false,
            sLoading4:false,
            sLoading5:false,
          getform:{
            site_cash:'',
          },
          getOptions:[
          {
              label:this.$i18n.t("msg.알잔액"),
              value:'sitem'
            },
            {
              label:this.$i18n.t("msg.카슬머니"),
              value:'apim'
            },
            
          ],
          getvalue:'sitem',
          getapim:'apim',
          apim:'',
          sitem:'',
          gubun:'',
          getModel:false,
          autoqaLoading:false,
          formLoading:false,
          modelFalse:false,
          admin_in:0,
          admin_out:0,
          point_trans:0,
          searchform:{
            keyword:''
          },
            idsearchform:{
            time:[],
            time7:[],
            time8:[],
             idsearchOptions3:[
            {
              label:this.$i18n.t("msg.전체"),
              value:'1011'
            },
            {
              label:this.$i18n.t("msg.알충"),
              value:'10'
            },
            {
              label:this.$i18n.t("msg.알환"),
              value:'11'
            },
           
            ],
            value3:'1011',
              idsearchOptions2:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.충전"),
              value:'1'
            },
            {
              label:this.$i18n.t("msg.알환"),
              value:'2'
            },
           
            ],
            value2:'',
             idsearchOptions:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.배팅"),
              value:'1'
            },
            {
              label:this.$i18n.t("msg.당첨"),
              value:'7'
            }


            ],
            value:'',

             idsearchOptions4:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.전환"),
              value:'2122'
            },
            {
              label:this.$i18n.t("msg.롤링"),
              value:'5'
            }


            ],
            value4:'',

 

             idsearchOptions1:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("searchText.카슬"),
              value:'api'
            },
           

            ],
            game_gubun:'',
          },
          level_opt1:[
            {
              label:this.$i18n.t("msg.기본"),
              value:'0'
            },
             {
              label:'V1',
              value:'1'
            },
             {
              label:'V2',
              value:'2'
            }
            ,
             {
              label:'V3',
              value:'3'
            },
             {
              label:'V4',
              value:'4'
            },
             {
              label:'V5',
              value:'5'
            },
             {
              label:'V6',
              value:'6'
            },
             {
              label:'V7',
              value:'7'
            }
            ],
           level_opt:[
            
             {
             label:this.$i18n.t("msg.매장"),
              value:'sp'
            },
             {
              label:this.$i18n.t("msg.총판"),
              value:'zp'
            },
             {
              label:this.$i18n.t("msg.부본"),
              value:'bubon'
            },
             {
              label:this.$i18n.t("msg.본사"),
              value:'bon'
            },
             {
              label:this.$i18n.t("msg.마스터"),
              value:'mst'
            }

            ],
           pickerOptions: {
          },
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          idcurrentPage:1,
          idtotal:0,
          idsize:0,
          tabList:[],
          autoQaContent:[],
          autoqaModel:false,
          tapId:'0',
          tabname:'',
           tabname2:'',
          activeIndex: 'tab1',
          activeName: 'tab6-1',
          activeName7: 'tab7-1',
            activeName8: 'tab8-1',
          memWidth:'500px',
          customWidth:'800px',
          reComModel:false,
         qaLoading:false,
          creatModel:false,
          checkAll: false,
          mtcreatModel:false,
          qa:[],
          reComData:[],
          level: [],
          cities: checkboxsOptions,
          isIndeterminate: true,
          domain:window.sessionStorage.getItem('domain'),
          userid:window.sessionStorage.getItem('userid'),
          power:window.sessionStorage.getItem('power'),
          rosing:window.sessionStorage.getItem('rosing'),
          outbet:window.sessionStorage.getItem('outbet'),
          sim:window.sessionStorage.getItem('sim'),
          ulevel:window.sessionStorage.getItem('level'),
          money_inout:window.sessionStorage.getItem('money_inout'),
          memIdData:[],
          dialogVisible: false,
          disabled:false,
          loading:false,
          sLoading7:false,
          loading7:false,
           sLoading8:false,
          loading8:false,
          loading4:false,
          editIndex:-1,
          memoform:{
            mem_id:'',
            content:'',
          },
          form:{
                memlist:[],
                    mem_lev:'',
            cash_b:'',
            outp:'',
            maxp:'',
            out_bet_power:'',
            out_bet_power_g:'',
            login_more:'0',
            api_money:0,
            power_cash:0,
            power_ecash:0,
            color:'',
            id_txt:'',
            bet_black:'',
            bet_black1:'',
            bet_black2:'',
            bet_black3:'',
            bet_black4:'',
            mem_name:'',
            mem_hp:'',
            mem_login:'',
            mem_id:'-',
            mem_emoney:0,

            mem_pw:'',
            mem_bankcode:'',
            mem_banknum: '',
            mem_bankname:'',
            mem_jumin:'',
            mem_zip:'',
            mem_regdate:'',
            mem_cash:'',
            mem_eventmoney:'',
            mem_ip:'',
            mem_raip:'',
            m_cp:'',
            mem_all_init:'',
             mem_all_e:'',
              mem_all_slot:'',
               mem_all_power:'',

            mem_memo:'',
            whitelist:'',
            mem_status:'',
            m_emoney:'',
            loging:'',
            logip:'',
            mem_login_date:'',
            a_code:'',
             m_code:'',
              s_code:'',
            last_money_date:'',
            in_money:'',
            out_money:'',
             pro_money:0,
            reset_money:'',
            off_out:'',
            off_in:'',  
            event_loing:'',
            event_loing_recom:'',
            event_loing_group:'',
            event_loing_group_recom:'',
            event_loing_s:'',
            event_loing_recom_s:'',
            event_loing_group_s:'',
            event_loing_group_recom_s:'',

            cash_b:'',
            event_loing1:'',
            event_loing_recom1:'',
            event_loing_group1:'',
            event_loing_group_recom1:'',
            event_loing_s1:'',
            event_loing_recom_s1:'',
            event_loing_group_s1:'',
            event_loing_group_recom_s1:'',



            event_boat_sambok: '',
            event_bokyeon: '',
            event_cycle_sambok: '',
            event_japan_sambok: '',
            event_japan_samsang: '',
            event_pro: '',
            event_pro_boat: '',
            event_pro_cycle: '',
            event_pro_japan: '',
            event_sambok: '',
            event_sang:'',


            event_loing_slot:'',
            event_loing_recom_slot:'',
            event_loing_e:'',
            event_loing_recom_e:'',

            last_out_money_date:'',
            reg_code:'',
            out_bet_power:'',
            out_bet_power_g:'',
            out_bet_sadari:'',
            out_bet_sadari_g:'',

           admin_id:'',

            b_code:'',
            pc_e:'',
            pc_slot:'',
            pc_p:'',
            mem_sms:'',
           
        

          },
           wr_1:'',
          urlLink:'https://blackstone-hk1.ppgames.net/gs2c/parentRoundHistoryDetails.do?playSessionId=10845692434823&stylename=blst_diamond2&hash=4d2fd93804bd9de97a2096e3317f719a&language=KO',
          level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")             
            },
            options: [{
              label: this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label: this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
              label:this.$i18n.t("msg.기본"),  
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }, {
              label: 'v6',
               value: '6',
             
            }, {
              label: 'v7',
               value: '7',
             
            }, {
              label: 'co',
               value: '8',
             
            }],
          memState:'',
          multipleSelection:[],
          autoloading:false,
          mem_status:'1',
          m_emoney:'',
          statusoptions: [{
              label: this.$i18n.t("msg.정상"),
              value: '1',
             
            },{
              label: this.$i18n.t("msg.탈퇴"),
               value: '0',
             
            }],
             statusoptions3: [{
              label: this.$i18n.t("msg.금지"),
              value: '0',
             
            },{
              label: this.$i18n.t("msg.가능"),
               value: '1',
             
            }],
            statusoptions2: [
            {
              label: '300만',
              value: '3000000',
             
            },
            {
              label: '500만',
              value: '5000000',
             
            },{
              label: '1000만',
               value: '10000000',
             
            },{
              label: '2000만',
               value: '20000000',
             
            }],
              rules: {
                  
                  wr_1:[{ required: true, message: '', trigger: 'blur'}],
                   money1:[{ required: true, message: '', trigger: 'blur'}],
                    money2:[{ required: true, message: '', trigger: 'blur'}],
                },

        
           
          
        }
      },

      created() {
         this.defaultDate();
         this.getProvide();

          // this.info.id父组件传给子组件的id值
          this.fetchManage(this.info.id);
         //console.log('model',this.model)
         this.activeIndex = this.activeTab
         let current1 = this.activeIndex;
        if(current1=='tab44'){
        this.tabname=current1
        this.tapId=3
        this.form.mem_id = this.info.id
        //console.log('created tabname===',this.form.mem_id)
        //console.log('tapid3',this.tapId)
          this.getTablist() //这里写一些跳转后必须要执行的函数
        }else if(current1=='tab4'){
          this.form.mem_id = this.info.id
          this.tabname2='tab7-1'
           this.getTablist7()
        }else if(current1=='tab48'){
          this.form.mem_id = this.info.id
          this.tabname2='tab8-1'
           this.getTablist8()
        }
        else if(current1=='tab6'){
          this.form.mem_id = this.info.id
          this.tabname2='tab6-1'
           this.getTablist5()
        }
         

             
    },
     computed:{
      minus(){
        return this.total_money - this.total_emoney
      },
        idDialogVisible: {
                get() {
                    return this.visible
                },
            },
             editor() {
        return this.$refs.myQuillEditor.quill;
    }

    },
      updated(){
    this.$nextTick(() => {
        this.$refs['table'].doLayout()  
         this.$refs['table2'].doLayout()  
          this.$refs['table3'].doLayout()   
          this.$refs['table4'].doLayout()  
          this.$refs['table5'].doLayout()
          this.$refs['table6'].doLayout() 
          
        // table是在表格中ref=‘table’
        // doLayout 对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
    })
}, 
      methods:{
        formatMemberLevel(value){
          const level = parseInt(value, 10)
          if(isNaN(level) || level < 0) return ''
          return level === 0 ? '기본' : 'V' + level
        },
        handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       func(state){
      if(state > 0){
        return "text-success"
      }else if(state <0){
         return "text-danger"
      }else if(state ===0){
         return ""
      }
    },
        tableRowClassName({row, rowIndex}) {
    
       if (rowIndex%2 === 1) {
        return 'odd-row-class';
       }
       else{
         return 'edd-row-class';
       }
    },
        cash_input(type){
          let token=window.sessionStorage.getItem('user');
           this.$refs.bonForm.validate((e)=>{
             if(!e) return;
             let cashTips="";
             if(type =="1"){
                cashTips=this.$i18n.t("msg.지급하시겠습니까")
             }else if(type=="2"){
               cashTips=this.$i18n.t("msg.차감하시겠습니까")
             }
            this.$confirm(cashTips, this.$i18n.t("msg.알림"), {
                confirmButtonText: this.$i18n.t("msg.확인"),
                cancelButtonText: this.$i18n.t("msg.취소"),
                 customClass: 'message-override',
                type: 'warning'
              }).then(() => {
                 this.layLoading = true
           
              this.$axios({
                    method:'post',
                    url:this.domain+'/user/cash_event_up',
                    data:{
                      mem_id:this.form.mem_id,
                      money:this.bonForm.money1,
                      memo:this.bonForm.memo1,
                      io_type:type,
                      gubun:'1',
                      code:'',
                      all:''
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
               
                     this.layLoading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
            

                     //this.bonForm.mem_id=''

                      this.form.mem_cash=response.data.mem_cash
                      this.form.mem_eventmoney=response.data.mem_eventmoney

                     this.bonForm.money1=''
                     this.bonForm.memo1=''
                      
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      }) 


                         this.tabname2="tab6-1"
                        this.getTablist5();

                      
                      //在这判断 layer_new打开的还是 memlist打开的
                      this.$parent.getList() 

                          EventBus.$emit('mem_cash', response.data.pt_cash)
                         EventBus.$emit('habu_apimoney', response.data.habu_apimoney)


                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                    this.layLoading = false
              })
               })
          

           })
        },
        cash_input1(type){
           this.$refs.bonForm1.validate((e)=>{
             if(!e) return;
              let cashTips="";
             if(type =="1"){
                cashTips=this.$i18n.t("msg.지급하시겠습니까")
             }else if(type=="2"){
               cashTips=this.$i18n.t("msg.차감하시겠습니까")
             }
            this.$confirm(cashTips, this.$i18n.t("msg.알림"), {
                confirmButtonText: this.$i18n.t("msg.확인"),
                cancelButtonText: this.$i18n.t("msg.취소"),
                type: 'warning'
              }).then(() => {
                  let token=window.sessionStorage.getItem('user');
           this.layLoading1 = true
           
              this.$axios({
                    method:'post',
                    url:this.domain+'/user/cash_event_up',
                    data:{
                      mem_id:this.form.mem_id,
                      money:this.bonForm1.money2,
                      memo:this.bonForm1.memo2,
                      io_type:type,
                      gubun:'2',
                      code:'',
                      all:''
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
               
                     this.layLoading1 = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
            

                     //this.bonForm.mem_id=''
                     this.bonForm1.money2=''
                     this.bonForm1.memo2=''

                         this.form.mem_cash=response.data.mem_cash
                      this.form.mem_eventmoney=response.data.mem_eventmoney
                      
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      }) 

                      
                      //在这判断 layer_new打开的还是 memlist打开的
                      this.$parent.getList() 
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                    this.layLoading1 = false
              })

              })
            

           })
        },
         getVal(e){

          if(this.bonForm.money1=='')
          {
this.bonForm.money1='0';
          }

          if(e=='0')
          {
            this.bonForm.money1='0';
          }

          this.bonForm.money1=parseInt(this.bonForm.money1)+parseInt(e)
          console.log(e)
        },
          getVal1(e){

          if(this.bonForm1.money2=='')
          {
this.bonForm1.money2='0';
          }

          if(e=='0')
          {
            this.bonForm1.money2='0';
          }

          this.bonForm1.money2=parseInt(this.bonForm1.money2)+parseInt(e)
          console.log(e)
        },

       change(e) {
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/user/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    console.log('url:',url.data.data)
                     const quill = this.$refs.myQuillEditor.quill
                      quill.focus()
                      quill.insertEmbed(quill.getSelection().index, 'image', url.data.data)
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },
     tableSortChange(column) {
 
         this.prop= column.prop
         this.order= column.order
         
        this.getTablist4()
     },

          onEditorReady(editor) { // 准备编辑器
        },
          onEditorBlur(){}, // 失去焦点事件
          onEditorFocus(){}, // 获得焦点事件
          onEditorChange(event){
              // console.log(event.html)
               // this.form.admin_contents = event.html
          }, 
          autoSubmit(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
              if (this.editIndex === -1) {
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/user/autoqa_add',
                        data:{
                          contents:this.autoForm.contents,
                          id:this.autoForm.id,
                          title:this.autoForm.title,
                          title2:this.autoForm.title2
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:'완료',
                                type:'success'
                               });
                               //console.log(this.form);
                               this.autoqaList();
                               //this.tableData.unshift(this.form)
                               //关闭
                            this.autocreatModel = false

                            }
                           this.autoloading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
            }else{
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/user/autoqa_up',
                      data:{
                          id:this.autoForm.id,
                          contents:this.autoForm.contents,
                          title:this.autoForm.title,
                          title2:this.autoForm.title2
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.autocreatModel = false
                       this.$message({
                           message:this.$i18n.t("msg.수정완료"),
                          type:'success'
                      })   
                    }else
                    {
                       this.autocreatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    this.autoqaList()
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
        getProvide(){
        let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/user/get_provider',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              console.log('providelist',response.data)
           let newids=[];

            let obj={};
            obj.label='전부'
            obj.value=''
            newids.push(obj);     

            response.data.data.forEach(item=>{
             obj={};
            obj.label=item.provider_name
            obj.value=item.provider_name
            newids.push(obj);            
           });


           

           this.providerlist=newids
    
            }).catch((error) =>{
              
            })

    },
       editCon(e = false){
          let token=window.sessionStorage.getItem('user');
          //tianjia
          if(!e){
            this.autoForm = {
                contents:'',
                title:'',
                title2:''
                 }
             this.editIndex = -1

          }
          else{
             //修改
            this.autoloading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/user/autoqa_id?id='+e.row.id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                 this.autoloading = false
                  let item = response.data.data
                  console.log('data==',item)
                  
                    this.autoForm = {
                          title:item.title,
                          contents:item.contents,
                          id:item.id,
                          title2:item.title2

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })


          }
        
          this.autocreatModel = true
         
        },
       // 批量删除
            deleteAll(){
                this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
                    confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
                    type: 'warning'
                }).then(() => {
                    let token=window.sessionStorage.getItem('user');

                    //console.log('hh',this.multipleSelection);

                    let newids=[];

                     this.multipleSelection.forEach(item=>{
                        
                        //console.log('id',item.idx);
                        if(typeof(item.idx) != "undefined")
                        {
                           newids.push(item.idx);
                        }else
                        {
                           newids.push(item.id);
                        }
                        
                     });

                     console.log('newids',newids);

                    this.$axios({
                            method:'post',
                             data:{idx:newids},
                            url:this.domain+'/user/memo_del',
                            'Accept': 'application/json',
                            headers: { 'Authorization': 'Bearer ' + token },
                            
                           
                        }).then((response) =>{ 
                            
                            if(response.data.code==200){
                                this.$message({
                                        message:response.data.msg,
                                        type:'success'
                                    })
                            }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                            this.getTablist()
    
                        }).catch((error) =>{
                            console.log(error)       //请求失败返回的数据
                        })
                        
       

                })

                
            },  
              getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if(index === 0){
             sums[index] = this.$i18n.t("msg.합계");
          }
         else if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 7) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 8) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 9) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 10) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 11) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 12) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 13) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 14) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 15) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 16) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 17) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 18) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 19) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
            searchQaEvent(){

                if(this.searchform.keyword==''){
                    this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                     return;
                }
                this.autoqaList();
                
             

            },
            autoqaList(){
                 let token=window.sessionStorage.getItem('user');
             this.autoqaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/user/autoqalist?page=1'+'&title='+this.searchform.keyword,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             console.log('data====',response.data.data)
                  let item = response.data.data 
                  //this.form.content=''
                  this.autoQaContent = item.data
                 
                  this.autoqaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
                this.autoqaModel = true
            },
        mtClick(){
          this.mtcreatModel = true
          this.mtLoad = true
           let token=window.sessionStorage.getItem('user');

            let s_time="";
               let e_time="";

               let v=this.tapId;

                 let ttname=this.tabname;

               if(this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }



           this.$axios({
                  method:'get',
                  url:this.domain+'/user/get_apimoneylist?mem_id='+this.info.id+'&s_time='+s_time+'&e_time='+e_time,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                    this.mtLoad = false
                    console.log(response.data.data.DATA)
                    let data = response.data.data.DATA
                    this.kennData = data
        
                    }).catch((error) =>{  

                      console.log('error',error.response)
                     
                   })
        },

        getList(){
         this.fetchManage(this.info.id);

        },

          bonOpen(e,id,type){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },

          couponOpen(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: coupon,
                parent: this,
                data:{
                
                info:{id:id,},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['520px', '550px'],
        });
        
        },
        wrOpen(id){
           this.$layer.iframe({
            type: 2,
            title: '쪽지확인',
            content: {
                content: wrDialog,
                parent: this,
                data:{
                
                info:{id:id,},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: [0.8,'#000'],
            area: ['520px', '380px'],
        });
        
        },
         openId(id,e){

if(id==this.form.mem_id)
          {
              return;
          }
  let pix=window.screen.width;
             let width='1000px';
                if(pix<1200)
                {
                  width='95%';
                }
           this.$layer.iframe({
            type: 2,
            title: id,
            content: {
                content: layerNew,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id',
                activeTab:e,
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: [width+'', '500px'],
           
        });
        
        },

         del_id(id){
    
          if(this.userid=='admin')
          {

              this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {


          let token=window.sessionStorage.getItem('user');
                 this.$axios({
                        method:'post',
                        url:this.domain+'/user/moneylogs_del',
                        data:{
                          idx:[id],     
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                               message:response.data.msg,
                                type: 'warning'
                               });
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                            }
                         
                     
                  }).catch((error) =>{
                      
                  })

            }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });

            
          }
         },
         del_idx(id){
    
          if(this.userid=='admin')
          {

            this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {


           let token=window.sessionStorage.getItem('user');
                 this.$axios({
                        method:'post',
                        url:this.domain+'/user/raceinout_del',
                        data:{
                          idx:[id],     
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                               message:response.data.msg,
                                type: 'warning'
                               });
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                            }
                         
                     
                  }).catch((error) =>{
                      
                  })
                  

           }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });


           
          }
         },
del_qa_idx(id){
    
        

        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {


           let token=window.sessionStorage.getItem('user');
                 this.$axios({
                        method:'post',
                        url:this.domain+'/user/autoqa_del',
                        data:{
                          idx:[id],     
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                               message:response.data.msg,
                                type: 'warning'
                               });
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });

                                  this.autoqaList();
                            }
                         
                     
                  }).catch((error) =>{
                      
                  })
                  

           }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });


           
          
         },
        getChange(v,type){
           var objVal = {}
              
             if(type=='1')
             {
                 if(v=='sitem')
                 {
                     this.getapim="apim"
                 }
                 if(v=='apim')
                 {
                     this.getapim='sitem'
                 }
             }
             if(type=='2')
             {
                 if(v=='sitem')
                 {
                     this.getvalue='apim'
                 }
                 if(v=='apim')
                 {
                     this.getvalue='sitem'
                 }
             }

              console.log(v)
              console.log(type)


        },
       
        submitGetm(){
          this.disabled = true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'post',
                  url:this.domain+'/user/exchange_gm_apim',
                  data:{
                    mem_id:this.form.mem_id,
                    cash:this.getform.site_cash,
                    type:this.getvalue
                  },
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                  this.loading = false

                      if(response.data.code==200)
                            {
                                         this.$message.success(response.data.msg);
                                         this.getModel=false
                                         this.form.api_money = response.data.apimoney
                                         this.form.mem_cash = response.data.gamemoney
                                        // this.form.api_money = response.data.apimoney
                                        
                            }else
                            {
                                         this.$message.error(response.data.msg);
                            }

                             this.disabled = false
                 
        
                    }).catch((error) =>{  

                       this.disabled = false

                      console.log('error',error.response)
                     
                   })
        },
         getm(){
          this.getModel=true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/user/getm?mem_id='+this.form.mem_id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                  this.loading = false
                    console.log(response.data.data)
                  let data = response.data.data
                   this.apim = data.apimoney
                   this.sitem = data.gamemoney
        
                    }).catch((error) =>{  

                      console.log('error',error.response)
                     
                   })

         },
          fetchManage(id){
            this.formLoading = true
            let token=window.sessionStorage.getItem('user');
            let that=this
            this.$axios({
                  method:'get',
                 
                   url:this.domain+'/user/mem?fit='+this.prop+'&order='+this.order+'&mem_id='+id,

                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.formLoading = false

                   if(response.data.code!=200)
                   {
 this.$message.error(response.data.msg)
 return;
                   }
                   let data = response.data.data
               
                   this.form = {
                        memlist:data.memlist,
                    mem_lev:data.mem_lev,
                    admin_id: data.admin_id,
                      id_txt: data.id_txt,
                      bet_black : data.bet_black,
                      sitetype:data.sitetype,
                      bg:this.bg,
                      ref:data.ref,
                      color:data.RaceYN,
                      mem_ing:data.mem_ing,
                      mem_name:data.mem_name,
                      api_money:data.api_money,
                      power_cash:data.power_cash,
                      power_ecash:data.power_ecash,
                      mem_emoney:data.mem_emoney,
                      mem_hp:data.mem_hp,
                      mem_login:data.mem_login,
                      mem_id:data.mem_id,
                      mem_pw:data.mem_pw,
                      mem_bankcode:data.mem_bankcode,
                      mem_banknum: data.mem_banknum,
                      mem_bankname:data.mem_bankname,
                      event_boat_sambok : data.event_boat_sambok,
                      event_bokyeon : data.event_bokyeon,
                      event_cycle_sambok : data.event_cycle_sambok,
                      event_japan_sambok : data.event_japan_sambok,
                      event_japan_samsang : data.event_japan_samsang,
                      event_pro : data.event_pro,
                      event_pro_boat : data.event_pro_boat,
                      event_pro_cycle : data.event_pro_cycle,
                      event_pro_japan : data.event_pro_japan,
                      event_sambok : data.event_sambok,
                      event_sang : data.event_sang,
                      login_more : data.login_more,
                      mem_jumin:data.mem_jumin,
                      mem_email:data.mem_email,
                      mem_zip:data.mem_zip,
                      mem_regdate:data.mem_regdate,
                      mem_cash:data.mem_cash,
                      max_bet:data.max_bet,
                      m_emoney:data.m_emoney,
                      bet_black1 : data.bet_black1,
                      bet_black2 : data.bet_black2,
                      bet_black3 : data.bet_black3,
                      bet_black4 : data.bet_black4,
                      t_delay:data.t_delay,
                      mem_eventmoney:data.mem_eventmoney,
                      mem_ip:data.mem_ip,
                      mem_raip:data.mem_raip,
                      m_cp:data.m_cp,
                      mem_all_init:data.mem_all_init,
                      mem_all_e:data.mem_all_e,
                      mem_all_slot:data.mem_all_slot,
                      mem_all_power:data.mem_all_power,
                      mem_memo:data.mem_memo,
                      whitelist:data.whitelist || '',
                      mem_status:data.mem_status,
                      memState:data.memState,
                      loging:data.loging,
                      logip:data.logip,
                      mem_login_date:data.mem_login_date,
                      a_code:data.a_code,
                      m_code:data.m_code,
                      s_code:data.s_code,
                      last_money_date:data.last_money_date,
                      in_money:data.in_money,
                      out_money:data.out_money,
                       pro_money:data.pro_money,
                      reset_money:data.reset_money,
                      off_in:data.off_in,
                      off_out:data.off_out,
                      event_loing:data.event_loing,
                      event_loing_recom:data.event_loing_recom,
                      event_loing_group:data.event_loing_group,
                      event_loing_group_recom:data.event_loing_group_recom,
                      event_loing_s:data.event_loing_s,
                      event_loing_recom_s:data.event_loing_recom_s,
                      event_loing_group_s:data.event_loing_group_s,
                      event_loing_group_recom_s:data.event_loing_group_recom_s,
                      cash_b:data.cash_b,
                      event_loing1:data.event_loing1,
                      event_loing_recom1:data.event_loing_recom1,
                      event_loing_group1:data.event_loing_group1,
                      event_loing_group_recom1:data.event_loing_group_recom1,
                      event_loing_s1:data.event_loing_s1,
                      event_loing_recom_s1:data.event_loing_recom_s1,
                      event_loing_group_s1:data.event_loing_group_s1,
                      event_loing_group_recom_s1:data.event_loing_group_recom_s1,
                      event_loing_recom_e:data.event_loing_recom_e,
                      event_loing_recom_slot:data.event_loing_recom_slot,
                      event_loing_e:data.event_loing_e,
                      event_loing_slot:data.event_loing_slot,
                      c_code:data.c_code,
                      last_out_money_date:data.last_out_money_date,
                      reg_code:data.reg_code,
                      out_bet_power:data.out_bet_power,
                      out_bet_power_g:data.out_bet_power_g,
                      out_bet_sadari:data.out_bet_sadari,
                      out_bet_sadari_g:data.out_bet_sadari_g,
                      b_code:data.b_code,
                      pc_e:this.formatMoney(data.pc_e),
                      pc_slot:this.formatMoney(data.pc_slot),
                      pc_p:this.formatMoney(data.pc_p),
                      mem_sms:data.mem_sms,
                      maxp:data.maxp,
                      outp:data.outp,
                      cash_b:data.cash_b,
                    }

                   
                     
               
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
      },
          handleTabClick(tab, event) {
             //console.log('handleTabClick tabname==',tab.name)
            this.tabname2='';

                this.tabname=tab.name
                this.tapId=tab.index

               this.idsearchform.time=[];
               this.idsearchform.time7=[];
               this.idsearchform.time8=[];
                 this.defaultDate();

             
               this.tabList=[];
                this.idcurrentPage=1
              if(this.tabname=="tab5") {
               this.getTablist4()
              }
              else if(this.tabname=="tab4") {
               
               this.activeName7='tab7-1';
               this.tabname2='tab7-1';
               this.getTablist7()
              }
              else if(this.tabname=="tab6") {
               
               this.activeName='tab6-1';
               this.tabname2='tab6-1';
               this.getTablist5()
              }
               else if(this.tabname=="tab48") {
               
               this.activeName8='tab8-1';
               this.tabname2='tab8-1';
               this.getTablist8()
              }else
              {
                this.getTablist();
              }
      },
      handleClick(tab, event){
          this.tabname2=tab.name
          this.tabname=tab.name
              this.tapId=tab.index

                this.idsearchform.time=[];
                 this.idsearchform.time7=[];
             this.idsearchform.time8=[];
               this.tabList=[];
               this.admin_in=0
               this.admin_out=0
                this.idcurrentPage=1
              this.getTablist5();

      },
       handleClick7(tab, event){
        this.tabname2=tab.name
          this.tabname=tab.name
              this.tapId=tab.index

               this.idsearchform.time=[];
               this.tabList=[];
                this.idcurrentPage=1
              this.getTablist7();

      },
      handleClick8(tab, event){
         this.tabname2=tab.name
          this.tabname=tab.name
              this.tapId=tab.index

               this.idsearchform.time=[];
               this.tabList=[];
                this.idcurrentPage=1
              this.getTablist8();

      },
      idsearchEvent(){
        this.sLoading  =true
        this.getTablist();
         this.idcurrentPage=1
        },
idsearchEvent4(){
        this.sLoading4  =true
         this.idcurrentPage=1
        this.getTablist4();
        },
        idsearchEvent5(){
           this.idcurrentPage=1
        this.sLoading5  =true
        this.getTablist5();
        },
         idsearchEvent7(){
           this.idcurrentPage=1
        this.sLoading7  =true
        this.getTablist7();
        },
         idsearchEvent8(){
           this.idcurrentPage=1
        this.sLoading8  =true
        this.getTablist8();
        },
         qaChange(index){
         
        console.log(this.qa[index].contents)
         
          this.wr_1  = this.qa[index].contents
 
        },
        addRcom(){
          this.reComModel = true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                  method:'get',
                   url:this.domain+'/user/mem?mem_id='+this.form.mem_id,
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.loading = false
                   let data = response.data.data
                   console.log('recom:',data.recom)
                   this.reComData = data.recom
                  
              
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
        },
          linkBtn(e){

           let token=window.sessionStorage.getItem('user');
           this.$axios({
            method: 'get',
            url: this.domain + '/user/getGameCategory',
            params: {
              provider_id: e.row.provider_id,
              game_id: e.row.game_id,
              provider_name: e.row.provider_name,
              opcode: e.row.opcode,
              admin_id: e.row.admin_id,
              dd: e.row.create_at,
              user_id: e.row.username,
              ping: e.row.ping,
              round_id: e.row.round_id,
              txid: e.row.txid
            },
            headers: {
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + token
            }
          }).then((response) =>{ 


              console.log('code',response.data.code)

             if ( response.data.code == "500")
             {
                 alert(response.data.msg);
             }
             
             else if(response.data.code=="300"){
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                       // table:{name:response.data.data.data.table.name},
                       // dealer:{name:response.data.data.data.dealer.name},
                      //  gameProvider:response.data.data.data.gameProvider,
                        banker_cards:response.data.data.data.result.banker.cards,
                        player_cards:response.data.data.data.result.player.cards,
                        outcome:response.data.data.data.result.outcome,
                        banker:{score:response.data.data.data.result.banker.score},
                        player:{score:response.data.data.data.result.player.score},
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }
             else if(response.data.code=="302"){
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                        banker_cards:response.data.data.result.banker.cards,
                        player_cards:response.data.data.result.player.cards,
                        outcome:response.data.data.result.outcome,
                        banker:{score:response.data.data.result.banker.score},
                        player:{score:response.data.data.result.player.score},
                        bets:response.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="303"){
            
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                       
                        
                        
                        bets:response.data.data.details.bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             } else if(response.data.code=="301"){


               if(typeof(response.data.data.detail.data.result.banker) == "undefined")
               {
                   this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                       
                        
                        
                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                  });
               }

               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                        banker_cards:response.data.data.detail.data.result.banker.cards,
                        player_cards:response.data.data.detail.data.result.player.cards,
                        outcome:response.data.data.detail.data.result.outcome,
                        banker:{score:response.data.data.detail.data.result.banker.score},
                        player:{score:response.data.data.detail.data.result.player.score},
                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="400"){
            
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                        table:{name:response.data.data.data.table.name},
                        dealer:{name:response.data.data.data.dealer.name},
                        gameProvider:response.data.data.data.gameProvider,
                       
                        
                        
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else
             {

                 window.open(response.data.data,'_blank')
             }
                 
                 
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

          console.log(e);

          //window.open(this.urlLink,'_blank')
        },
         playertransaction(id){
           this.$layer.iframe({
            type: 2,
            title: 'API내역',
            content: {
                content: playertransaction,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['750px', '300px'],
           
           
        });
        },
        memoSend(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
           
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/user/memo_send',
                        data:{
                           content:this.wr_1,
                          mem_id:this.form.mem_id,
                          level:this.level,
                          gubun:this.gubun,
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                              
                            
                            this.creatModel = false

                            this.getTablist();

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
        
            })
              
            
        },
        add(){

             console.log('test')
             let token=window.sessionStorage.getItem('user');
             this.qaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/user/autoqalist?type=memo',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //console.log('data====',response.data.data)
                 
                 
                  
                let item = response.data.data 
                  this.wr_1=''
                  this.qa = item
                  this.qaLoading = false 
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          this.creatModel = true

        },
         handleCheckAllChange(val) {
            this.level = val ? checkboxsOptions : [];
            this.isIndeterminate = false;
          },
          handlelevelChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
          },
        memModel(){
          this.getData()
          this.dialogVisible = true
          this.loading = true
        },
         getTablist4(){
               let s_time="";
               let e_time="";

               // let v=this.tapId;

               //   let ttname=this.tabname;

               if(this.idsearchform.time && this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }


           
             this.loading4 = true

             let token=window.sessionStorage.getItem('user');
             let urls='';
            
             if(this.form.sitetype=='4')
             {
                urls=this.domain+'/user/apibetlist_id?limit='+this.idsize+'&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&provider_name='+this.provider_name+'&fit='+this.prop+'&order='+this.order+'&habu='+this.habu;
             }
             
             
         

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     //console.log('tabdata=',response.data)
                     let data = response.data.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data

                     this.ain = response.data.ain
                     this.aout = response.data.aout

                     this.total_emoney = response.data.total_emoney
                     this.total_rog = response.data.total_rog
                     this.total_money = response.data.total_money
                     this.total_money_e = response.data.total_money_e
                     this.total_money_slot = response.data.total_money_slot
                     this.total_emoney_e = response.data.total_emoney_e
                     this.total_emoney_slot = response.data.total_emoney_slot

                      this.total_money_d = response.data.total_money_d
                     
                      this.total_money_z = response.data.total_money_z

                       this.total_emoney_d = response.data.total_emoney_d
                     
                      this.total_emoney_z = response.data.total_emoney_z
                   

                     this.loading4 = false
                     this.sLoading4 = false

                   
               
            }).catch((error) =>{
               this.loading = false
               
            })
        },
        getTablist5(){
               let s_time="";
               let e_time="";

               // let v=this.tapId;

                let ttname=this.tabname2;

               console.log('ttname',ttname)

               if(this.idsearchform.time && this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }


           
             this.loading5 = true

             let token=window.sessionStorage.getItem('user');
             let urls='';
            
             if(ttname=="tab6-1")
             {
                urls=this.domain+'/user/moneylogs_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&admin_in='+this.admin_in+'&admin_out='+this.admin_out+'&log=1';
             }
             else if(ttname=="tab6-2")
             {
                urls=this.domain+'/user/moneylogs_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&admin_in='+this.admin_in+'&admin_out='+this.admin_out+'&point_trans='+this.point_trans+'&log=2'+'&game_gubun='+'&type=';
             }else if(ttname=="tab6-3")
             {
               this.total_emoney = '0';
               this.total_money = '0';
               urls=this.domain+'/user/moneylist_id?io_type='+this.idsearchform.value2+'&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab6-4")
             {
                urls=this.domain+'/user/moneylogs_id?type='+this.idsearchform.value3+'&game_gubun='+this.idsearchform.game_gubun+'&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab6")
             {
               urls=this.domain+'/user/moneylogs_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&admin_in='+this.admin_in+'&admin_out='+this.admin_out+'&log=1';
             }
             
         

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     //console.log('tabdata=',response.data)
                     let data = response.data.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data


                     this.loading5 = false
                     this.sLoading5 = false

                     if(ttname=="tab6-3")
                     {
                       this.total_emoney = response.data.total_emoney
                       this.total_money = response.data.total_money
                     }
                       if(ttname=="tab6-1")
                     {
                       this.ain = response.data.ain
                       this.aout = response.data.aout
                     }
                     if(ttname=="tab6-4")
                     {
                       this.ain = response.data.ain
                       this.aout = response.data.aout
                     }

                   
               
            }).catch((error) =>{
               this.loading = false
               
            })
        },
        getTablist8(){
               let s_time="";
               let e_time="";

               // let v=this.tapId;

                let ttname=this.tabname2;

             



               if(this.idsearchform.time8!=null && this.idsearchform.time8.length>0)
               {
                  s_time=this.idsearchform.time8[0];
                  e_time=this.idsearchform.time8[1];
               }


           
             

             let token=window.sessionStorage.getItem('user');
             let urls='';

             console.log('ttname',ttname);
            
             if(ttname=="tab8-1")
             {
                urls=this.domain+'/user/calculation_new?xia=1&habu=1&mem_id='+this.form.mem_id+'&gubun=all'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             else if(ttname=="tab8-2")
             {
                urls=this.domain+'/user/calculation_new?xia=1&habu=1&mem_id='+this.form.mem_id+'&gubun=live'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
              else if(ttname=="tab8-3")
             {
                urls=this.domain+'/user/calculation_new?xia=1&habu=1&mem_id='+this.form.mem_id+'&gubun=slot'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             } else if(ttname=="tab48")
             {
                urls=this.domain+'/user/calculation_new?xia=1&habu=1&mem_id='+this.form.mem_id+'&gubun=slot'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else
             {
               console.log("else getTablist8")
               return;
             } 


             this.loading8 = true
         

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('tabdata7=',response.data)
                     let data = response.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data


                     this.loading8 = false
                     this.sLoading8 = false

                   
               
            }).catch((error) =>{
               this.loading8 = false
               
            })
        },
         getTablist7(){
               let s_time="";
               let e_time="";

               // let v=this.tapId;

                 let ttname=this.tabname2;

             



               if(this.idsearchform.time7!=null && this.idsearchform.time7.length>0)
               {
                  s_time=this.idsearchform.time7[0];
                  e_time=this.idsearchform.time7[1];
               }


           
             

             let token=window.sessionStorage.getItem('user');
             let urls='';

             console.log('ttname',ttname);
            
             if(ttname=="tab7-1")
             {
                urls=this.domain+'/user/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=all'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             else if(ttname=="tab7-2")
             {
                urls=this.domain+'/user/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=live'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
              else if(ttname=="tab7-3")
             {
                urls=this.domain+'/user/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=slot'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             } else if(ttname=="tab4")
             {
                urls=this.domain+'/user/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=slot'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else
             {
               console.log("else getTablist7")
               return;
             } 


             this.loading7 = true
         

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('tabdata7=',response.data)
                     let data = response.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data


                     this.loading7 = false
                     this.sLoading7 = false

                   
               
            }).catch((error) =>{
               this.loading7 = false
               
            })
        },
          getTablist(){


               let s_time="";
               let e_time="";
                 let s_time7="";
               let e_time7="";
                 let s_time8="";
               let e_time8="";
               let v=this.tapId;
               let ttname2=this.tabname2;
                 let ttname=this.tabname;

              if(ttname=="tab5")
             {
               this.getTablist4();
               return;
             }

               if( this.idsearchform.time && this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }
               else if(this.idsearchform.time7!=null && this.idsearchform.time7.length>0){
                 s_time7=this.idsearchform.time7[0];
                  e_time7=this.idsearchform.time7[1];
               } else if(this.idsearchform.time8!=null && this.idsearchform.time8.length>0){
                 s_time8=this.idsearchform.time8[0];
                  e_time8=this.idsearchform.time8[1];
               }else
               {

               }

            if(v=="0")
            {
              this.fetchManage(this.info.id);
              return
            }
             this.loading = true
              this.loading4 = true
               this.loading5 = true
                this.loading7 = true
                 this.loading8 = true
             let token=window.sessionStorage.getItem('user');
             let urls='';
             if(ttname=="tab2")
             {
                urls=this.domain+'/user/acclist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             else if(ttname=="tab3")
             {
                urls=this.domain+'/user/moneylogs_id?log=1&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab4")
             {

               urls=this.domain+'/user/calculation_new?x=tab4&xia=1&mem_id='+this.form.mem_id+'&gubun=all&s_time='+s_time7+'&e_time='+e_time7;
             }else if(ttname=="tab48")
             {

               urls=this.domain+'/user/calculation_new?x=tab4&xia=1&habu=1&mem_id='+this.form.mem_id+'&gubun=all&s_time='+s_time8+'&e_time='+e_time8;
             }else if(ttname=="tab444")
           {
             urls=this.domain+'/user/moneylogs_id?type='+this.idsearchform.value+'&log=0&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else if(ttname=="tab44")
             {
               urls=this.domain+'/user/memolist?s_time='+s_time+'&e_time='+e_time+'&attn='+this.form.mem_id+'&page='+this.idcurrentPage;
             }
            else if(ttname=="tab6")
             {
               urls=this.domain+'/user/moneylogs_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&log=1';
             }else if(ttname=="tab7")
             { 

           
                urls=this.domain+'/user/mchangelist?s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage;  
             
             
           
           }else if(ttname=="tab8")
           { 

            urls=this.domain+'/user/acclist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             
           
           }else
           {
            return;
           }

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('tabdata=',response.data.data)
                     let data = response.data.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page


                     if(ttname=="tab4")
                     {
                        this.tabList =data
                        this.loading7 = false
                        this.sLoading7 = false

                       
                        return;
                     }
                     if(ttname=="tab48")
                     {
                        this.tabList =data
                        this.loading8 = false
                        this.sLoading8 = false

                       
                        return;
                     }
                     if(ttname=="tab5"){
                      this.loading4 = false
                       this.getTablist4()
                       return;
                     }
                     this.tabList =data.data

                     //return;

                     this.ain = response.data.ain
                     this.aout = response.data.aout

                     this.total_emoney = response.data.total_emoney
                     this.total_rog = response.data.total_rog
                     this.total_money = response.data.total_money
                     this.total_money_e = response.data.total_money_e
                     this.total_money_slot = response.data.total_money_slot
                     this.total_emoney_e = response.data.total_emoney_e
                     this.total_emoney_slot = response.data.total_emoney_slot

                      this.total_money_d = response.data.total_money_d
                     
                      this.total_money_z = response.data.total_money_z

                       this.total_emoney_d = response.data.total_emoney_d
                     
                      this.total_emoney_z = response.data.total_emoney_z
                   

                     this.loading = false
                     this.sLoading = false
                      this.loading5 = false
                      this.loading7 = false

                   
               
            }).catch((error) =>{
               this.loading = false
               
            })
        },
         idhandleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
               this.idsize = val
              this.getTablist();
              this.loading= true

            },
            idhandleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.idcurrentPage = val
              this.getTablist();
              this.loading= true
            },
              idhandleCurrentChange5(val) {
              //console.log(`当前页: ${val}`);
              this.idcurrentPage = val
              this.getTablist5();
              this.loading5= true
            },
              defaultDate() {
                  var date = new Date()
                  var year = date.getFullYear().toString()
                  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
                  var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
                  // var da = new Date(date.getFullYear(), month, 0).getDate()
                  da < 10 ? '0' + da.toString() : da.toString()
                  var beg = year + '-' + month + '-01'
                  var end = year + '-' + month + '-' + da
                  this.idsearchform.time7 = [beg, end] 
                   this.idsearchform.time8 = [beg, end] 
                  console.log('time',beg)
                },
        getData(){
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/user/mem_by_inout_date?mem_id='+this.form.mem_id;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('data=',response.data)
                     let data = response.data.data
                     this.memIdData =data
                     let inmoney=0;
                     let outmoney=0;
                     data.map(function(item)
                     {
                        inmoney+=parseInt(item.inm)
                        outmoney+=parseInt(item.outm)
                     })

                     let total={date: "total", inm: inmoney, outm: outmoney};

                     this.memIdData.push(total);
                     this.loading = false

                   
               
            }).catch((error) =>{
              // if(error.response.status==401)
              // {
              //   this.$router.push({name:'login'})

              // }
                console.log('error',error.response)       //请求失败返回的数据
               
            })
        },

        Cancel(){
           this.$layer.close(this.layerid);
            this.$parent.cancelEvent();
        },
     
      
        Save(){
           this.$confirm(this.$i18n.t("msg.수정하시겠습니까"), this.$i18n.t("msg.알림"), {
             confirmButtonText: this.$i18n.t("msg.수정"),
          cancelButtonText: this.$i18n.t("msg.취소"),
         
          type: 'warning'
        }).then(() => {

          this.disabled = true
              this.formLoading  = true
              let token=window.sessionStorage.getItem('user');
              this.$axios({
                      method:'post',
                      url:this.domain+'/user/mem_up',
                      data:this.form,   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{

                   // console.log('response',response);

                   if(response.data.code==200){
                       this.disabled = false
                       this.formLoading = false
                       this.$layer.close(this.layerid);
                        this.$parent.cancelEvent();
                          console.log('modelpop===',this.modelpop)
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.$parent.getList()   
                    }else
                    {
                      this.disabled = false
                      this.$parent.formLoading = false
                      // this.$parent.idDialogVisible = false
                      // this.idDialogVisible = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨"),
          });          
        });
              
     
        },

         Del(){
           this.$prompt(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
             confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
           inputPlaceholder:this.$i18n.t("newAdd.인증번호"),
         
          type: 'warning'
        }).then(({ value }) => {
          this.disabled = true
              this.formLoading  = true
              let token=window.sessionStorage.getItem('user');
              this.$axios({
                      method:'post',
                      url:this.domain+'/user/mem_del?opt='+value+'&mem_id='+this.form.mem_id,
                     
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{

                    this.disabled = false
                       this.formLoading = false
 this.$parent.formLoading = false

                   if(response.data.code==200){
                      
                       this.$layer.close(this.layerid);
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.$parent.getList()   
                    }else
                    {
                      
                     
                      // this.$parent.idDialogVisible = false
                      // this.idDialogVisible = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨"),
          });          
        });
              
     
        },
         apiMoney(type){
            
        
          let token=window.sessionStorage.getItem('user');
          let that=this;
          this.$axios({
                      method:'get',
                      url:this.domain+'/user/getapimoney?mem_id='+this.form.mem_id,
                     
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                  
                    if(response.data.code==200){

                       this.$message({
                      message:this.$i18n.t("msg.갱신완료"),
                      type:'success'
                    })
                     
                      that.form.api_money=response.data.data
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      
                  })
        },

          resetMoney(type){
            let mtype='';
                     if(type==1)
                      {
                        mtype=this.$i18n.t("msg.게임머니");
                      }
                      else if(type==2)
                      {
                     
                       mtype=this.$i18n.t("msg.이벤트머니"); 
                        
                      }
                      else if(type==3)
                      {
                        mtype=this.$i18n.t("msg.롤링머니");
                      }
                      else if(type==4)
                      {
                        mtype=this.$i18n.t("msg.배팅누적");
                      }


          this.$confirm(mtype+this.$i18n.t("msg.리셋하시겠습니까"), this.$i18n.t("msg.알림"),{
            confirmButtonText: this.$i18n.t("msg.취소"),
          cancelButtonText: this.$i18n.t("msg.리셋"),
      
       
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/user/reset_money',
                      data:{
                      mem_id:this.form.mem_id,
                      type:type
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                      if(type==1)
                      {
                       this.form.mem_cash = '0'
                      }
                      else if(type==2)
                      {
                       this.form.mem_eventmoney='0'
                        
                        
                      }
                      else if(type==3)
                      {
                       this.form.mem_ing='0'
                      }
                      else if(type==4)
                      {
                       this.form.mem_all_init='0'
                      }
                      
                     
              
                      //this.$parent.getList()
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message:  this.$i18n.t("msg.취소됨"),
          });          
        });

     
        },
         mlogout(){
          
                     


          this.$confirm(this.form.mem_id+this.$i18n.t("msg.아웃하시겠습니까"), this.$i18n.t("msg.알림"), {
           confirmButtonText: this.$i18n.t("msg.아웃"),
          cancelButtonText: this.$i18n.t("msg.취소"),
            
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/user/mem_out',
                      data:{
                      mem_id:this.form.mem_id
                      
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                       this.form.loging='0'
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message:this.$i18n.t("msg.취소됨")
          });          
        });

     
        },
        
        handleClose() {
                this.$emit('handleClose')
            },

      
      }
  }
</script>
<style>
  .layer-table th,.layer-table td{
    text-align: center;
    color: #222;
    padding:8px
  }
  .layer-table thead th{
    background-color: #eceff1;
  }
  .layer-table td{
    font-size:14px !important
  }
/deep/ .el-dialog__body{
  padding:5px 10px;
}
/deep/ .el-dialog__header{
  padding:2px 20px 10px
}
.flexNo{
  display: block;
}
.myflex{
  margin-left: -80px;
}
>>>.el-tabs__header{
  margin-bottom: 5px;
}.boxflex {
  
    color: #3d3a3a;
    border: 1px solid #f1f1f1;
    width: 98%;
    text-align: center;
    margin-bottom: 10px;
  
}

.boxflex h2 {
    color: #2c2b2b;
    font-size: 14px;
    background-color: #e4e4e4;
    height: 32px;
    line-height: 32px;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item{
  color: #333 !important;font-weight: bold !important;
}
.el-tabs--border-card>.el-tabs__header{
    background-color:#e4e5e6 !important;
  }
.el-tabs--card>.el-tabs__header .el-tabs__item{
   background-color:#e4e5e6 !important;
}
.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
  background-color:#fff !important
}
.card-header{
  background-color:#eceff1 !important
}
.el-form-item__label{
  color:#000;
}
.member-id-row{
  display:flex;
  align-items:center;
  width:100%;
  gap:6px;
}
.member-id-row .el-input{
  flex:1;
}
.member-level{
  flex:0 0 auto;
  padding:1px 5px;
  border-radius:3px;
  background:#eef2f7;
  color:#495057;
  font-size:11px;
  line-height:18px;
}
.logout-danger{
 
  background-color:#d9534f;
  margin-left:5px;
}
.el-textarea.is-disabled .el-textarea__inner,.el-input.is-disabled .el-input__inner{
  color:#000;
}
  .autoTable .el-button--mini{
      padding:5px;margin:0px;font-size:10px !important
    }
    .ql-container.ql-snow{
      height:150px
    }
    .el-tabs--border-card>.el-tabs__content{
      padding:5px 10px;
    }
.el-message-box__wrapper{
     z-index: 4000 !important;
     background:rgba(0,0,0,.4)
  }
.el-picker-panel{
  z-index:12000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/layer-new.vue